import { cn } from '@/lib/utils';
import { testGapCardClass, testGapPageClass } from './test-gap-layout';

const SkeletonBar = ({ className }: { className?: string }) => (
  <div
    className={cn(
      'animate-pulse rounded-md bg-[var(--inv-surface-muted)]',
      className,
    )}
  />
);

export function TestGapCompareSkeleton() {
  return (
    <section className={testGapCardClass} aria-hidden="true">
      <div className="mb-3 flex flex-wrap items-start justify-between gap-3 2xl:mb-4">
        <div className="min-w-0 flex-1">
          <SkeletonBar className="mb-2 h-5 w-24" />
          <SkeletonBar className="h-3.5 w-[min(100%,22rem)]" />
        </div>
        <SkeletonBar className="h-9 w-[11rem] shrink-0 rounded-[10px]" />
      </div>

      <div className="hidden grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-end gap-x-5 min-[769px]:grid">
        <div className="flex flex-col gap-2">
          <SkeletonBar className="h-3 w-24" />
          <SkeletonBar className="h-10 w-full rounded-[10px]" />
        </div>
        <SkeletonBar className="mx-1 h-[1.35rem] w-[1.35rem] shrink-0 rounded-full" />
        <div className="flex flex-col gap-2">
          <SkeletonBar className="h-3 w-20" />
          <SkeletonBar className="h-10 w-full rounded-[10px]" />
        </div>
      </div>

      <div className="flex flex-col gap-4 min-[769px]:hidden">
        <div className="flex flex-col gap-2">
          <SkeletonBar className="h-3 w-24" />
          <SkeletonBar className="h-10 w-full rounded-[10px]" />
        </div>
        <SkeletonBar className="mx-auto h-[1.35rem] w-[1.35rem] rounded-full" />
        <div className="flex flex-col gap-2">
          <SkeletonBar className="h-3 w-20" />
          <SkeletonBar className="h-10 w-full rounded-[10px]" />
        </div>
      </div>

      <div className="mt-4 flex justify-end border-t border-[var(--inv-border-soft)] pt-3 2xl:mt-5 2xl:pt-4">
        <SkeletonBar className="h-10 w-52 rounded-[10px]" />
      </div>
    </section>
  );
}

const TestGapSkeleton = () => (
  <div
    className={cn(testGapPageClass, 'animate-pulse')}
    aria-busy="true"
    aria-label="Loading test gap analysis">
    <header className="mb-5 max-w-[42rem]">
      <SkeletonBar className="mb-3 h-2.5 w-28" />
      <SkeletonBar className="mb-2 h-8 w-[min(100%,14rem)]" />
      <SkeletonBar className="h-4 w-[min(100%,34rem)]" />
    </header>

    <SkeletonBar className="mb-4 h-11 w-full rounded-xl" />

    <TestGapCompareSkeleton />
  </div>
);

export default TestGapSkeleton;
